import { useContext } from "react";
import {
  WizardContext,
  type WizardContextValue,
} from "../components/WizardContext";

/**
 * Read the wizard context from within any screen rendered under
 * `WizardProvider`.
 *
 * @throws if called outside a `WizardProvider`.
 */
export function useWizard(): WizardContextValue {
  const ctx = useContext(WizardContext);
  if (!ctx) {
    throw new Error("useWizard must be used within a WizardProvider");
  }
  return ctx;
}
